import { Incident } from '@/types/community/incident';

// Helper function to get dates relative to current date
function getRelativeDate(daysOffset: number, hour: number = 9, minute: number = 0): Date {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
}

export const incidents: Incident[] = [
  // Recent incidents (last few days)
  {
    id: 'INC001',
    title: 'Fuga de Agua en Área Común',
    description: 'Agua filtrándose del techo en el área del lobby',
    type: 'safety',
    priority: 'high',
    status: 'investigating',
    reportedBy: {
      id: 'resident-1',
      name: 'Carlos Rodríguez',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-1, 8, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Equipo de Mantenimiento'
    },
    attachments: [
      {
        id: 'ATT001',
        name: 'leak_photo.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/documents/incidents/INC001/leak_photo.jpg',
        url: 'https://example.com/photos/leak.jpg',
        uploadedAt: getRelativeDate(-1, 8, 0)
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC002',
    title: 'Ascensor Averiado',
    description: 'El ascensor en el Bloque A no está funcionando correctamente',
    type: 'other',
    priority: 'high',
    status: 'investigating',
    reportedBy: {
      id: 'resident-2',
      name: 'María López',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-2, 10, 0),
    assignedTo: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC003',
    title: 'Actividad Sospechosa',
    description: 'Persona sospechosa merodeando en el área de estacionamiento',
    type: 'security',
    priority: 'medium',
    status: 'resolved',
    reportedBy: {
      id: 'EMP004',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-3, 22, 0),
    resolvedAt: getRelativeDate(-2, 0, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC004',
    title: 'Corte de Energía',
    description: 'Corte de energía afectando el Bloque B',
    type: 'other',
    priority: 'high',
    status: 'investigating',
    reportedBy: {
      id: 'resident-3',
      name: 'Pedro García',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-4, 15, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Equipo de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC005',
    title: 'Queja de Ruido',
    description: 'Ruido excesivo del apartamento 3B',
    type: 'noise',
    priority: 'low',
    status: 'investigating',
    reportedBy: {
      id: 'resident-4',
      name: 'Ana Martínez',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-5, 23, 0),
    assignedTo: {
      id: 'EMP001',
      name: 'Guardia de Seguridad'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Past week incidents
  {
    id: 'INC006',
    title: 'Ventana Rota',
    description: 'Ventana rota en área común',
    type: 'other',
    priority: 'medium',
    status: 'investigating',
    reportedBy: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-6, 9, 0),
    assignedTo: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC007',
    title: 'Prueba de Alarma de Incendio',
    description: 'Prueba programada del sistema de alarma de incendio',
    type: 'safety',
    priority: 'low',
    status: 'reported',
    reportedBy: {
      id: 'EMP004',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-7, 8, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC008',
    title: 'Mantenimiento de Piscina',
    description: 'Mal funcionamiento del sistema de filtros de la piscina',
    type: 'safety',
    priority: 'medium',
    status: 'resolved',
    reportedBy: {
      id: 'EMP005',
      name: 'Acompañante de Piscina',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-8, 7, 0),
    resolvedAt: getRelativeDate(-8, 12, 0),
          assignedTo: {
        id: 'EMP003',
        name: 'Personal de Mantenimiento'
      },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC009',
    title: 'Vehículo No Autorizado',
    description: 'Vehículo no autorizado estacionado en lugar de residente',
    type: 'security',
    priority: 'medium',
    status: 'investigating',
    reportedBy: {
      id: 'EMP001',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-9, 16, 0),
    assignedTo: {
      id: 'EMP001',
      name: 'Guardia de Seguridad'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC010',
    title: 'Interrupción de Internet',
    description: 'Servicio de internet caído en el Bloque C',
    type: 'safety',
    priority: 'high',
    status: 'in_progress',
    reportedBy: {
      id: 'resident-5',
      name: 'Sara Wilson',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-10, 14, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Equipo de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Past month incidents
  {
    id: 'INC011',
    title: 'Falla del Sistema HVAC',
    description: 'Sistema de calefacción no funciona en el Bloque A',
    type: 'safety',
    priority: 'high',
    status: 'resolved',
    reportedBy: {
      id: 'resident-6',
      name: 'David Brown',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-15, 6, 0),
    resolvedAt: getRelativeDate(-14, 18, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Equipo de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC012',
    title: 'Detección de Fuga de Gas',
    description: 'Fuga de gas detectada en el apartamento 2C',
    type: 'safety',
    priority: 'critical',
    status: 'resolved',
    reportedBy: {
      id: 'resident-7',
      name: 'Lisa Davis',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-18, 19, 0),
    resolvedAt: getRelativeDate(-18, 22, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Equipo de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC013',
    title: 'Vandalismo de Buzones',
    description: 'Buzones dañados en el lobby',
    type: 'security',
    priority: 'medium',
    status: 'resolved',
    reportedBy: {
      id: 'EMP001',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-20, 8, 0),
    resolvedAt: getRelativeDate(-19, 14, 0),
    assignedTo: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC014',
    title: 'Queja de Fiesta Ruidosa',
    description: 'Ruido excesivo del apartamento 4A',
    type: 'noise',
    priority: 'high',
    status: 'resolved',
    reportedBy: {
      id: 'resident-8',
      name: 'Tom Wilson',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-22, 22, 0),
    resolvedAt: getRelativeDate(-22, 23, 0),
    assignedTo: {
      id: 'EMP001',
      name: 'Guardia de Seguridad'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC015',
    title: 'Problema del Panel Eléctrico',
    description: 'Mal funcionamiento del panel eléctrico en el sótano',
    type: 'maintenance',
    priority: 'high',
    status: 'resolved',
    reportedBy: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-25, 10, 0),
    resolvedAt: getRelativeDate(-24, 16, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Equipo de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Older incidents
  {
    id: 'INC016',
    title: 'Daño de Auto en Estacionamiento',
    description: 'Auto rayado en el estacionamiento',
    type: 'security',
    priority: 'medium',
    status: 'resolved',
    reportedBy: {
      id: 'resident-9',
      name: 'Emma Thompson',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-30, 16, 0),
    resolvedAt: getRelativeDate(-29, 10, 0),
    assignedTo: {
      id: 'EMP001',
      name: 'Guardia de Seguridad'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC017',
    title: 'Emergencia de Plomería',
    description: 'Problema mayor de plomería en el apartamento 1B',
    type: 'maintenance',
    priority: 'critical',
    status: 'resolved',
    reportedBy: {
      id: 'resident-10',
      name: 'Alex Rodriguez',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-35, 7, 0),
    resolvedAt: getRelativeDate(-33, 20, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Equipo de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC018',
    title: 'Fuga del Techo',
    description: 'Agua filtrándose del techo en el Bloque C',
    type: 'maintenance',
    priority: 'high',
    status: 'resolved',
    reportedBy: {
      id: 'resident-11',
      name: 'María García',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-40, 9, 0),
    resolvedAt: getRelativeDate(-38, 17, 0),
    assignedTo: {
      id: 'EMP003',
      name: 'Personal de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC019',
    title: 'Mal Funcionamiento de Alarma de Incendio',
    description: 'Alarma de incendio falsa activada',
    type: 'safety',
    priority: 'medium',
    status: 'resolved',
    reportedBy: {
      id: 'EMP004',
      name: 'Guardia de Seguridad',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-45, 14, 0),
    resolvedAt: getRelativeDate(-45, 15, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Equipo de Mantenimiento'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC020',
    title: 'Violación de Disposición de Basura',
    description: 'Residente no cumple las reglas de disposición de basura',
    type: 'other',
    priority: 'low',
    status: 'resolved',
    reportedBy: {
      id: 'EMP005',
      name: 'Personal de Limpieza',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-50, 11, 0),
    resolvedAt: getRelativeDate(-49, 13, 0),
    assignedTo: {
      id: 'EMP001',
      name: 'Guardia de Seguridad'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  }
]; 